import styled from 'styled-components'

export const BuildingPermitsTabContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`

export const BuildingPermitsTabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background: ${({ theme }) => theme.colors.background.primary};
  overflow-y: auto;
  overflow-x: hidden;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.background.secondary};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.border.default};
    border-radius: 4px;

    &:hover {
      background: ${({ theme }) => theme.colors.border.default};
    }
  }
`

export const BuildingPermitsTabContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
`
